<template>
    <div id="forgot-password">
        <ValidationObserver ref="observer">
            <v-form action="/password/email" method="post">
                <v-card tile>

                    <v-toolbar color="primary" flat dark>
                        <v-toolbar-title>{{ translations.app_name }} {{ translations.auth.reset_password }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                    </v-toolbar>

                    <v-card-text>

                        <v-alert type="error" dismissible v-model="hasError">
                            {{ n_errors[0] }}
                        </v-alert>

                        <v-alert type="success" dismissible v-model="hasSuccess">
                            {{ translations.passwords.sent }}
                        </v-alert>

                        {{ translations.auth.forgot_password_text }}

                        <ValidationProvider rules="required" v-slot="{ errors }" :name="translations.auth.username">
                            <v-text-field
                                :label="translations.auth.username"
                                prepend-inner-icon="fas fa-user"
                                type="text"
                                name="username"
                                v-model="input.username"
                                :error-messages="errors[0]"
                            ></v-text-field>
                        </ValidationProvider>

                        <input type="hidden" name="_token" :value="csrf">

                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="primary" text href="/login">{{ translations.auth.login }}</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="primary" type="submit" @click.native="submit">{{ translations.auth.reset_password }}</v-btn>
                    </v-card-actions>

                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
    export default {
        name: "ForgotPassword",
        props: {
            username: String,
            trans: String|Object,
            errors: String|Array,
            success: String,
            csrf: String,
        },
        data() {
            return {
                input: {
                    username: '',
                },
                translations: {
                    app_name: 'eTender',
                    auth: {
                        reset_password: 'Reset Password',
                        forgot_password_text: 'Please enter your username to request a password reset',
                        login: 'Login',
                        username: 'Username',
                    },
                    passwords: {
                        sent: 'We have e-mailed your password reset link!',
                    },
                },
                n_errors: [],
            };
        },
        computed: {
            hasError() {
                return this.n_errors.length > 0;
            },
            hasSuccess() {
                return !! this.success;
            }
        },
        methods: {
            async submit(event) {
                let valid = await this.$refs.observer.validate();

                if (! valid) {
                    event.preventDefault();
                }
            },
            getTranslations(translations) {
                let key,
                    translated = {};

                if (typeof translations === 'string') {
                    translations = JSON.parse(translations);
                }

                for (key in translations) {
                    if (!translations.hasOwnProperty(key)) {
                        continue;
                    }

                    if (typeof translations[key] !== 'string') {
                        translations[key] = this.getTranslations(translations[key]);
                    }

                    translated[key] = translations[key];
                }

                return translated;
            },
        },
        created() {
            this.input.username = this.username;

            if (typeof this.errors == 'string') {
                this.n_errors = JSON.parse(this.errors);
            } else {
                this.n_errors = this.errors;
            }

            this.translations = this.getTranslations(this.trans);
        },
    };
</script>

<style scoped>

</style>
